import useStore from "./AppStore"
import Hero from "./Html/Hero"
import Presents from "./Html/Presents"
import Text from "./Html/Text"
import { motion, AnimatePresence } from 'framer-motion'

export default function Content(props){
  
  const lang = useStore(state => state.lang)
  const initial = useStore(state => state.initial)

  return (
    <motion.section id={`content`} animate={{opacity: initial ? 0 : 1}} initial={false}>
        <Presents
          start={0}
          end={300}
          content={lang
            ? <>
            <h2>InfinitePay</h2>
            <h1>A rede de pagamentos<br/>interplanetária</h1>
            <h3>Apresenta:</h3>
            </>
            : <>
            <h2>InfinitePay</h2>
            <h1>The interplanetary<br/>payment network</h1>
            <h3>Presents:</h3>
            </>
          }
        />
        <Hero
          start={600}
          end={800}
          content={lang
          ? <>
            <h1>BRLC</h1>
            <h3>Sua porta de entrada para a&nbsp;economia&nbsp;da&nbsp;web&nbsp;3.0</h3>
          </>
          : <>
            <h1>BRLC</h1>
            <h3>Your gateway to the web&nbsp;3.0&nbsp;economy</h3>
          </>
          }
        />
        <Text
          title={lang ? <>Conquistar o mundo é&nbsp;pouco</> : <>Conquering the world is&nbsp;not&nbsp;enough</>}
          text={lang
            ? [<><p>O que a gente mais quer é que nossos
              clientes tenham um sucesso estratosférico.</p>
              <p>Não, mais que isso: um sucesso intergalático.</p></>,
              <p>Com o BRLC abrimos as portas da economia da Web 3.0
              para empreendedores brasileiros - um universo de
              transparência, confiança e descentralização com transações
              financeiras mais baratas, rápidas e seguras.</p>]
            : [<p>We want our clients to be not just globally successful, but to find astronomical success.</p>,
              <p>BRLC gives Brazilian entrepreneurs access to the Web 3.0 economy.
              It's a world of transparency, trust and decentralization which offers cheaper,
              faster and safer financial transactions.</p>]}
          start={1500}
          end={2000}
          align="left"
        />
        <Text
          title={lang ? <>O que é o BRLC?</> : <>What is BRLC?</>}
          text={lang
          ? [<p>O BRLC é a <em>stablecoin</em> (criptomoeda estável)
            criada e emitida em Blockchain pela
            InfinitePay.</p>,<><p>Ela vale o mesmo que o Real brasileiro (R$).
            Esse valor é fixo, ou seja, não sofre variação
            cambial.</p><p><strong>1 BRLC = R$ 1. SEMPRE.</strong></p></>]
          : [<p>BRLC is a stablecoin created and issued on Blockchain by&nbsp;InfinitePay.</p>,
            <><p>It's worth the same as the Brazilian Real (R$),
            so there are no exchange rates affecting its value.</p>
            <p><strong>1 BRLC = R$ 1. ALWAYS.</strong></p></>]}
          start={2800}
          end={3200}
          align="right"
        />
        <Text
          title={lang ? <>Por que a InfinitePay&nbsp;criou uma&nbsp;criptomoeda?</> : <>Why did InfinitePay create a cryptocurrency?</>}
          text={lang
          ? [<p>As operações feitas com <em>stablecoins</em> (criptomoedas estáveis),
            são mais baratas, menos burocráticas e muito mais ágeis do que as tradicionais.
            </p>,<p>Por exemplo: já tentou mandar dinheiro para alguém no exterior?
            Se sim, você sabe o quanto de taxas e tarifas incidem sobre o total
            que você quer enviar. Uma transferência de <em>stablecoins</em> levaria segundos
            e teria <strong>custo zero</strong>.</p>]
          : [<p>Transactions made with stablecoins are cheaper,
            less bureaucratic and far more agile than traditional currency transfers.</p>,
            <p>Have you ever sent money abroad? If you have, you’ll know how much extra you pay in fees and charges. A stablecoin transaction happens in seconds and costs nothing.</p>]}
          start={4000}
          end={5000}
          align="left"
        />
        <Text
          title={lang ? <>O que eu posso fazer com&nbsp;o&nbsp;BRLC?</> : <>What can I do with BRLC?</>}
          text={lang ? [
            <p>O BRLC não tem data de validade,
            então pode ser "acumulado" na sua carteira InfinitePay.</p>,
            <>
              <p>Se você quiser, pode movimentar seu saldo assim:</p>
              <p>1. Enviar BRLCs para outras contas da Rede InfinitePay.</p>
              <p>2. Enviar BRLCs para carteiras de criptoativos</p>
            </>,
            <>
              <p>Logo, você vai poder trocar seus BRLCs por outros tokens
                - como Bitcoin, Ethereum, Doge Coin e USDC -
                dentro do App InfinitePay. Também vai dar para mandar o saldo,
                em reais, para contas bancárias por PIX.</p>
            </>
          ] : [  
            <p>BRLC never expire, so they can be stored in your InfinitePay&nbsp;wallet.</p>,
            <>
              <p>You can also move them around as follows:</p>
              <p>1. Send BRLC to other accounts on the InfinitePay network</p>
              <p>2. Send BRLC to cryptocurrency wallets</p>
            </>,
            <>
              <p>Soon, you’ll be able to make in-app swaps between BRLC and other cryptocurrencies like Bitcoin, Ethereum, Doge Coin and USDC. You’ll also be able to make withdrawals in Brazilian Reais straight into your bank account through PIX.</p>
            </>
          ]}
          start={6000}
          end={8000}
          align="right"
        />
      </motion.section>
  )
}


